import { Sprite, Text, Texture } from 'pixi.js';
import { AutoSpinView } from '../../view/auto_spin/AutoSpinView';
import { COMPONENTS, EVENTS } from '../../lib/constants';
import { GameConfigs } from '../../lib/globals/GameConfigs';
import HELPERS from '../../lib/globals/helpers/Helpers';
// import { Easing, Tween } from "@tweenjs/tween.js";
const events = [
	EVENTS.AUTO_STARTED,
	EVENTS.IS_DISABLED,
	EVENTS.SETTINGS_UPDATE,
	EVENTS.MODAL,
	EVENTS.ALL_LINES_FINISHED,
	EVENTS.ERROR_PAGE,
	EVENTS.NOTIFICATION,
	EVENTS.SERVER_MSG,
	EVENTS.BET_PLACED,
	EVENTS.REEL_FINISHED
];

class AutoSpinController {
	constructor(vc, conf) {
		this.vc = vc.holder;
		this.config = conf;
		this.isBonusMode = false;
		this.enabled = false;
		if (this.vc.getChildByName(this.config.modal)) {
			this.item = this.vc.getChildByName(this.config.modal);
			this.item.handler = this.handler.bind(this);
			this.initIcons();
			this.checkBonus();
			this.item.setActive(GameConfigs.autospin.isAutoOn);
			//TOOD stop auto on bonus win & some events
		} else {
			throw new Error(
				'AutoSpinController failed init ' + JSON.stringify(this.config)
			);
		}
	}

	checkBonus() {
		if (GameConfigs.config.hasbonus) {
			this.item.interactive = false;
			this.isBonusMode = true;
		} else {
			this.item.interactive = true;
			this.isBonusMode = false;
			this.addEventListeners();
			window.addEventListener(EVENTS.BONUS_BUY, this, false);
		}
	}

	addEventListeners() {
		for (let i = 0; i < events.length; i++) {
			window.addEventListener(events[i], this, false);
		}
		if (
			GameConfigs.settings.keyboard_shortcuts &&
			!window.isMobile &&
			!window.isTablet
		) {
			this.enabled = true;
			window.addEventListener('keydown', this, false);
		}
	}

	handler() {
		if (!this.item.interactive) {
			// window.sm.play({ name: "error_sfx" });
			// this.animateDisable();
			return;
		}
		this.handleAutoModal();
	}

	initIcons() {
		const item = this.item;
		item.inf = new Sprite(Texture.from(this.config.infinity));
		item.inf.anchor.set(0.5);
		item.inf.y = 8;
		item.inf.alpha = 0;
		item.text = new Text(
			window.lm[this.config.text].value,
			window.lm[this.config.text].config
		);
		item.text.anchor.set(0.5);
		item.text.y = 8;
		item.text.alpha = 0;
		//add components to auto button
		this.vc.ui_btn_auto.addChild(item.inf);
		this.vc.ui_btn_auto.addChild(item.text);
	}

	handleEvent(evt) {
		switch (evt.type) {
			case EVENTS.IS_DISABLED:
				if (evt.detail.disable.auto) {
					this.item.interactive = false;
				} else {
					this.item.interactive = true;
				}
				break;
			case EVENTS.MODAL:
				this.modalEvent(evt);
				if (!window.isMobile && !window.isTablet) return;
				if (
					evt.detail.modal === 'settings' ||
					evt.detail.modal === 'quest' ||
					evt.detail.modal === 'quest_claim' ||
					GameConfigs.bonusBuy
				) {
					this.item.interactive = false;
				} else {
					// if (!GameConfigs.quest_claim.step) {
					this.item.interactive = true;
					// }
				}
				break;
			case EVENTS.BONUS_BUY:
				this.isBonusMode = evt.detail.bonus;
				if (evt.detail.bonus) {
					this.item.interactive = false;
				} else {
					this.item.interactive = true;
				}

				break;
			case EVENTS.AUTO_STARTED:
				this.autoEvent(evt);
				break;
			case EVENTS.REEL_FINISHED:
				if (GameConfigs.bonusBuy && GameConfigs.notification.code === 0) {
					this.removeListeners();
				}
				break;
			case EVENTS.SETTINGS_UPDATE:
				if (window.isMobile || window.isTablet) return;
				if (evt.detail.data.keyboard_shortcuts === undefined) return;
				if (evt.detail.data.keyboard_shortcuts) {
					if (this.enabled) return;
					this.enabled = true;
					window.addEventListener('keydown', this, false);
				} else {
					this.enabled = false;
					window.removeEventListener('keydown', this, false);
				}
				break;
			case 'keydown':
				if (evt.keyCode === 65) {
					this.keyDownEvent(evt);
				}
				break;
			case EVENTS.ERROR_PAGE:
				this.handleStopAuto();
				this.removeListeners();
				window.removeEventListener(EVENTS.BONUS_BUY, this, false);
				break;
			case EVENTS.NOTIFICATION:
				evt.detail.notification && this.handleStopAuto();
				break;
			case EVENTS.BET_PLACED:
				if (evt.detail.placed) {
					if (GameConfigs.autospin.numOfBets === '') return;
					const betsLeft =
						GameConfigs.autospin.numOfBets - GameConfigs.autospin.leftBets;
					this.item.text.text = betsLeft;
				}
				break;
			default:
				break;
		}
	}

	modalEvent(e) {
		if (e.detail.modal === 'auto_spin') {
			this.item.setActive(true);
		}
		if (e.detail.modal !== 'auto_spin' && !GameConfigs.autospin.isAutoOn) {
			this.item.setActive(false);
		}
	}

	autoEvent(e) {
		const item = this.item;
		if (!e.detail.isAutoOn) {
			item.text.text = '';
			item.text.alpha = 0;
			item.inf.alpha = 0;
			// setTimeout(() => {
			this.item.setActive(false);
			// }, 10);
		} else {
			item.iconActive.alpha = 0;
			// setTimeout(() => {
			this.item.setActive(true);
			// }, 10);
			if (e.detail.numOfBets !== '') {
				item.text.text = e.detail.numOfBets;
				item.inf.alpha = 0;
				item.text.alpha = 1;
			} else {
				item.text.text = '';
				item.inf.alpha = 1;
				item.text.alpha = 0;
			}
		}
	}

	keyDownEvent(event) {
		if (this.item.interactive) {
			this.handler();
		}
	}

	handleModalEvent = (e) => {
		HELPERS.dispatchCustomEvent(EVENTS.MODAL, { modal: e });
	};

	//handlePause

	handleStopAuto() {
		if (!GameConfigs.autospin.isAutoOn) return;
		HELPERS.dispatchCustomEvent(EVENTS.AUTO_STARTED, {
			numOfBets: GameConfigs.autospin.numOfBets,
			isAutoOn: false,
			leftBets: 0,
			pause: false
		});
		// GameConfigs.autospin.isAutoOn = false;
		// GameConfigs.autospin.leftBets = 0;
		this.item.setActive(false);
	}

	handleAutoModal() {
		if (GameConfigs.autospin.isAutoOn) {
			this.handleStopAuto();
			return;
		}
		if (GameConfigs.modal === 'auto_spin') {
			this.handleModalEvent('');
		} else {
			this.handleModalEvent('auto_spin');
			GameConfigs.uiComponent.addView(AutoSpinView);
			GameConfigs.uiComponent[COMPONENTS.AUTO_SPIN].CloseController.onClose(
				() => {
					// this.item.interactive = true
					// GameConfigs.uiComponent.removeView(GameConfigs.uiComponent[this.config.item])
					// delete GameConfigs.uiComponent[this.config.item]
				}
			);
		}
	}

	removeListeners() {
		this.item.interactive = false;
		for (let i = 0; i < events.length; i++) {
			window.removeEventListener(events[i], this, false);
		}
		window.removeEventListener('keydown', this, false);
	}
}

export default AutoSpinController;
